// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 768px)","grid":"TwoColumnGrid_grid__p5xoA"};